interface ScoreGaugeProps {
  /** `null` = score non mesure (donnee absente) : on affiche un tiret, jamais un 0 invente. */
  score: number | null | undefined
  label: string
  size?: 'sm' | 'lg'
}

/** Gris neutre quand le score est inconnu. */
const UNKNOWN_COLOR = '#C8CBD8'

function scoreColor(score: number): string {
  if (score >= 90) return '#10B981'
  if (score >= 70) return '#84CC16'
  if (score >= 50) return '#FBBF24'
  if (score >= 30) return '#F97316'
  return '#EF4444'
}

export function ScoreGauge({ score, label, size = 'lg' }: ScoreGaugeProps) {
  const hasScore = typeof score === 'number' && Number.isFinite(score)
  const r = size === 'lg' ? 36 : 24
  const cx = size === 'lg' ? 48 : 32
  const dim = size === 'lg' ? 96 : 64
  const sw = size === 'lg' ? 5 : 3
  const circumference = 2 * Math.PI * r
  const dashoffset = hasScore ? circumference * (1 - (score as number) / 100) : circumference
  const color = hasScore ? scoreColor(score as number) : UNKNOWN_COLOR

  return (
    <div className="flex flex-col items-center gap-1">
      <div className="relative" style={{ width: dim, height: dim }}>
        <svg width={dim} height={dim} className="-rotate-90">
          <circle cx={cx} cy={cx} r={r} fill="none" stroke="#E2E4ED" strokeWidth={sw} />
          <circle
            cx={cx} cy={cx} r={r} fill="none"
            strokeWidth={sw}
            strokeDasharray={circumference}
            strokeDashoffset={dashoffset}
            strokeLinecap="round"
            stroke={color}
            className="transition-all duration-700"
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="font-bold font-mono leading-none" style={{ color, fontSize: size === 'lg' ? 22 : 14 }}>
            {hasScore ? score : '—'}
          </span>
          <span className="text-[#555A73] text-[10px]">{hasScore ? '/100' : 'n/d'}</span>
        </div>
      </div>
      <span className="text-[#8B8FA7] font-medium" style={{ fontSize: size === 'lg' ? 13 : 11 }}>{label}</span>
    </div>
  )
}
